// extracted by mini-css-extract-plugin
module.exports = {"container":"Sessions_container__1O_lg","btnNewSession":"Sessions_btnNewSession__2WQJP","btn":"Sessions_btn__1F7QE"};